import * as MediaPreviewType from '../../constants/MediaPreviewType.js';
import MediaPreviewEmbed from '../MediaPreviewEmbed/MediaPreviewEmbed';

const getActualUrl = (url: string) => {
  try {
    const parsed = new URL(url);
    const { pathname } = parsed;
    if (!pathname.startsWith('/shorts/')) {
      return '';
    }
    const idPart = pathname.slice('/shorts/'.length);
    const actualUrl = `https://youtube.com/watch?v=${idPart}`;
    return actualUrl;
  } catch {
    return '';
  }
};

function MediaPreviewYoutubeShort({
  url,
  getHeightOfIframe,
}: {
  url: string;
  getHeightOfIframe?: (previewType: number) => number;
}) {
  // hack
  const actualUrl = getActualUrl(url);
  if (!actualUrl) {
    return <div>Youtube Short URL could not be parsed</div>;
  }
  const heightOfIframe = getHeightOfIframe?.(MediaPreviewType.EmbedYoutubeShort) || 136;
  return (
    <MediaPreviewEmbed
      url={actualUrl}
      getHeightOfIframe={() => heightOfIframe}
      testId="MediaPreviewYoutubeShort"
    />
  );
}

export default MediaPreviewYoutubeShort;
